module.exports = __webpack_public_path__ + "static/media/email.f40fb483.png";